import { Injectable } from '@angular/core'
import { IEmployerDetailsVM } from '@candidate/app/models/employer/employer.model'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class LandingStateService {
  employer$?: BehaviorSubject<IEmployerDetailsVM> = new BehaviorSubject({} as IEmployerDetailsVM)
  constructor() {}
}
